import React from "react";
import { TabPanel, TabPanels } from "@chaser/components";
import NavigationTabs from "../../components/NavigationTabs";
import PageContainer from "../../components/PageContainer/index";
import Integrations from "./components/Integrations";
import UsersTable from "./components/UsersTable/index";
import Subscriptions from "./components/Subscriptions/index";
import Organisation from "./components/Organisation/index";
import Roles from "./components/Roles";
import useFetch from "../../hooks/useFetch/index";
import SettingsService from "../../services/settings-service";
import useShortCode from "../../hooks/useShortCode";
import useOrganisation from "../../hooks/useOrganisation";
import { roles } from "@/util/constants";

const Settings = () => {
  const shortCode = useShortCode();
  const { sandbox } = useOrganisation();
  const { data, refetch, applyOptimisticUpdate } = useFetch(
    SettingsService.getUsers,
    shortCode,
  );
  const tabs = [
    { path: "organisation", title: "Organisation info" },
    { path: "users", title: "Users" },
    {
      path: "roles",
      title: "Roles",
      requiredRoles: [roles.owner, roles.manager],
    },
    { path: "subscription", title: "Subscription" },
    {
      path: "integration",
      title: "Integration",
      hidden: sandbox,
      requiredRoles: [roles.owner, roles.manager],
    },
  ];

  return (
    <PageContainer>
      <NavigationTabs basePath="/settings" tabs={tabs} menuOnMobile>
        <TabPanels>
          <TabPanel>
            <Organisation />
          </TabPanel>
          <TabPanel>
            <UsersTable
              users={data}
              applyOptimisticUpdate={applyOptimisticUpdate}
              refetch={refetch}
            />
          </TabPanel>
          <TabPanel>
            <Roles users={data} applyOptimisticUpdate={applyOptimisticUpdate} />
          </TabPanel>
          <TabPanel>
            <Subscriptions users={data} />
          </TabPanel>
          <TabPanel hidden={sandbox}>
            <Integrations />
          </TabPanel>
        </TabPanels>
      </NavigationTabs>
    </PageContainer>
  );
};

export default Settings;
